export const ROOM_COLORS = {
  living_room: '#E8F5E9',
  bedroom: '#E3F2FD',
  kitchen: '#FFF3E0',
  bathroom: '#E0F7FA',
  dining_room: '#FFF8E1',
  office: '#F3E5F5',
  hallway: '#ECEFF1',
  garage: '#CFD8DC',
  laundry: '#E1F5FE',
  balcony: '#F1F8E9'
};

export const ROOM_TYPES = [
  { value: 'living_room', label: 'Sala de Estar' },
  { value: 'bedroom', label: 'Quarto' },
  { value: 'kitchen', label: 'Cozinha' },
  { value: 'bathroom', label: 'Banheiro' },
  { value: 'dining_room', label: 'Sala de Jantar' },
  { value: 'office', label: 'Escritório' },
  { value: 'hallway', label: 'Corredor' },
  { value: 'garage', label: 'Garagem' },
  { value: 'laundry', label: 'Lavanderia' },
  { value: 'balcony', label: 'Varanda' }
];

export const FLOOR_PLAN_CANVAS_WIDTH = 800;
export const FLOOR_PLAN_CANVAS_HEIGHT = 600;
export const FLOOR_PLAN_GRID_SIZE = 20;
export const FLOOR_PLAN_SCALE = 20;

export const drawFloorPlanEditorCanvas = (canvas, editorState) => {
  const { showGrid, rooms, tool, roomPoints, currentPoint, walls, isDrawing, startPoint, selectedRoomType } = editorState;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, FLOOR_PLAN_CANVAS_WIDTH, FLOOR_PLAN_CANVAS_HEIGHT);

  if (showGrid) {
    ctx.strokeStyle = '#E5E7EB';
    ctx.lineWidth = 0.5;

    for (let x = 0; x <= FLOOR_PLAN_CANVAS_WIDTH; x += FLOOR_PLAN_GRID_SIZE) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, FLOOR_PLAN_CANVAS_HEIGHT);
      ctx.stroke();
    }

    for (let y = 0; y <= FLOOR_PLAN_CANVAS_HEIGHT; y += FLOOR_PLAN_GRID_SIZE) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(FLOOR_PLAN_CANVAS_WIDTH, y);
      ctx.stroke();
    }
  }

  rooms.forEach((room) => {
    if (room.points.length <= 2) {
      return;
    }

    ctx.fillStyle = room.color || ROOM_COLORS[room.room_type] || '#E0E0E0';
    ctx.beginPath();
    ctx.moveTo(room.points[0].x, room.points[0].y);
    room.points.forEach((point, index) => {
      if (index > 0) {
        ctx.lineTo(point.x, point.y);
      }
    });
    ctx.closePath();
    ctx.fill();

    const centerX = room.points.reduce((sum, point) => sum + point.x, 0) / room.points.length;
    const centerY = room.points.reduce((sum, point) => sum + point.y, 0) / room.points.length;
    ctx.fillStyle = '#374151';
    ctx.font = '12px Inter, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(room.name, centerX, centerY);
  });

  if (tool === 'room' && roomPoints.length > 0) {
    ctx.fillStyle = `${ROOM_COLORS[selectedRoomType]}80`;
    ctx.beginPath();
    ctx.moveTo(roomPoints[0].x, roomPoints[0].y);
    roomPoints.forEach((point, index) => {
      if (index > 0) {
        ctx.lineTo(point.x, point.y);
      }
    });
    if (currentPoint) {
      ctx.lineTo(currentPoint.x, currentPoint.y);
    }
    ctx.closePath();
    ctx.fill();

    ctx.fillStyle = '#3B82F6';
    roomPoints.forEach((point) => {
      ctx.beginPath();
      ctx.arc(point.x, point.y, 5, 0, Math.PI * 2);
      ctx.fill();
    });
  }

  ctx.strokeStyle = '#1F2937';
  ctx.lineWidth = 8;
  ctx.lineCap = 'round';
  walls.forEach((wall) => {
    ctx.beginPath();
    ctx.moveTo(wall.start_x, wall.start_y);
    ctx.lineTo(wall.end_x, wall.end_y);
    ctx.stroke();
  });

  if (tool === 'wall' && isDrawing && startPoint && currentPoint) {
    ctx.strokeStyle = '#3B82F6';
    ctx.lineWidth = 8;
    ctx.beginPath();
    ctx.moveTo(startPoint.x, startPoint.y);
    ctx.lineTo(currentPoint.x, currentPoint.y);
    ctx.stroke();
  }
};
